import { render, staticRenderFns } from "./CommunicationsTable.vue?vue&type=template&id=7f6b5c81&scoped=true"
import script from "./CommunicationsTable.vue?vue&type=script&lang=js"
export * from "./CommunicationsTable.vue?vue&type=script&lang=js"
import style0 from "./CommunicationsTable.vue?vue&type=style&index=0&id=7f6b5c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b5c81",
  null
  
)

export default component.exports